import { createStyles } from "@material-ui/core";

export type OfficesClassKey = "pageTitle";

export const OfficesStyleRules = createStyles({
  pageTitle: {
    marginTop: "40px",
  },
});
